<template lang='pug'>
.parcel
	h1.title {{ parcel.q }}
</template>

<script>

import Submit from '@/lib/Submit';
import { objectOrNull } from '@/lib/vue-validators';
import { editParcel } from '@/lib/generate';

export default {
	name : 'parcel',

	props : {
		parcel : {
			required  : true,
			validator : objectOrNull,
		}
	},

	methods : {

		editParcel() {

			const changedParcel = editParcel( this.parcel );

			Submit.editParcel( changedParcel, this.parcel.key, 'Editing Parcel Status...' );
		}

	}
};
</script>

<style lang='scss'>

.parcel {
	display: flex;
	flex-flow: row;
	width: 100%;

	.title {
		width: 100%;
	}
}

</style>
